import useNoticeAdditional from './useNoticeAdditional'
import MyAccordion from '../../../../../control/accordion/accordion'
import { Grid, useTheme, makeStyles, Typography } from '@material-ui/core'
import useTranslate from '../../../../../i18n/useTranslate'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../../utilities/date'

export type ResultOfConsiderViewType = ReturnType<typeof useNoticeAdditional> & NoticeAdditionalType

const NoticeAdditionalDocumentView: React.FC<ResultOfConsiderViewType> = (props) => {
    const { projectData } = props

    const translate = useTranslate()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'))
    const isIPadView = useMediaQuery(theme.breakpoints.down('md'))
    const classes = useStyles({ isMobileView, isIPadView })

    const getDisplaySendDocumentDate = () => {
        let display = '-'
        if (projectData?.sendDocumentDate) {
            display =
                translate.languageStore.currentLanguage === translate.languageKey.th
                    ? convertDateToFormatTH(projectData?.sendDocumentDate)
                    : convertDateToFormatEN(projectData?.sendDocumentDate)
        }
        return display
    }

    return (
        <Grid item xs={12} md={12} lg={12}>
            <MyAccordion title={translate.get('LABEL.ADDITIONAL_DOC')}>
                <Grid container spacing={4}>
                    <Grid container item xl={6} lg={6} md={6} xs={12}>
                        <Grid item xs={12} md={12} lg={6}>
                            <Typography variant={'body2'} style={{}}>
                                {`${translate.get('LABEL.REQUIRE_SENT_DOC')}${
                                    translate.languageStore.currentLanguage === translate.languageKey.th
                                        ? 'หรือไม่'
                                        : ''
                                }`}{' '}
                                :{' '}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={6}>
                            <Typography variant={'body2'} className={classes.typography}>
                                {projectData?.isRequestDocument
                                    ? translate.get('LABEL.NEED')
                                    : translate.get('LABEL.NOT_NEED')}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container item xl={6} lg={6} md={6} xs={12}>
                        <Grid item xs={12} md={12} lg={5}>
                            <Typography variant={'body2'}>{translate.get('LABEL.NUMBER_OF_DOC_TO_SENT')} : </Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={7}>
                            <Typography variant={'body2'}>
                                {projectData?.documentNumber
                                    ? projectData?.documentNumber + ` ${translate.get('LABEL.DOC_UNIT')}`
                                    : '-'}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container item xs={12}>
                        <Grid item xs={12} md={12} lg={3}>
                            <Typography variant={'body2'}>
                                {translate.get('LABEL.DOC_SUBMITTED_DEADLINE')} :{' '}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={9}>
                            <Typography variant={'body2'}>{getDisplaySendDocumentDate()}</Typography>
                        </Grid>
                    </Grid>

                    <Grid container item xs={12}>
                        <Grid item xs={12} md={12} lg={3}>
                            <Typography variant={'body2'}>{translate.get('LABEL.REMARK')} : </Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={9}>
                            <Typography variant={'body2'} style={{ wordBreak: 'break-word' }}>
                                {projectData?.documentRemark || '-'}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </MyAccordion>
        </Grid>
    )
}
//Controler
export type NoticeAdditionalType = {
    callbackSaveComplete?: (resStatus: number, isDraft: boolean) => void
    isHideDocumentCertificate?: boolean
}
const NoticeAdditional: React.FC<NoticeAdditionalType> = (props) => {
    const useNoticeAdditionalModel = useNoticeAdditional(props)
    return <NoticeAdditionalDocumentView {...useNoticeAdditionalModel} {...props} />
}
const useStyles = makeStyles((theme) => ({
    spacingButton: {
        marginBottom: '10px',
    },
    paper: {
        width: '100%',
        height: 128,
        padding: 20,
    },
    titleFont: {
        color: '#BDBDBD',
    },
    contentFont: {
        fontWeight: 'bold',
    },

    typography: {
        marginLeft: (props: any) => {
            let value = '0px'
            if (props.isMobileView || props.isIPadView) {
                value = '0px'
            } else {
                value = '6px'
            }
            return value
        },
    },
}))

export default NoticeAdditional
